import React, { Component } from "react"

import BackgroundImage from "./BackgroundImage"
import StyledCheckbox from "./StyledCheckbox"

class PlaceholderImageEditWidget extends Component {
    constructor(props) {
        super(props)
        this.fileElement = null
        this.onAddHandler = this.onAddHandler.bind(this)
        this.onImageSelect = this.onImageSelect.bind(this)
        this.onUpdatePlaceholder = this.onUpdatePlaceholder.bind(this)
        this.onRemovePlaceholder = this.onRemovePlaceholder.bind(this)
    }

    onAddHandler() {
        this.fileElement.click()
    }

    onImageSelect() {
        if (this.fileElement.files)
            this.props.onAddPlaceholders(this.fileElement.files)
    }

    onUpdatePlaceholder({ target: { name, value } }) {
        const { placeholders } = this.props
        placeholders
            .filter(({ id, url }) => name === (id || url))
            .forEach(placeholder =>
                this.props.onUpdatePlaceholder({
                    ...placeholder,
                    attribution: value
                })
            )
    }

    onRemovePlaceholder(placeholder) {
        const that = this
        return () => {
            that.props.onRemovePlaceholder(placeholder)
        }
    }

    render() {
        const {
            placeholders,
            isInheritEnabled,
            isInheritingPlaceholders,
            onEventChange
        } = this.props
        return (
            <div className="widget">
                <h3 className="widget-header">
                    <span className="icon icon-heroimg" />
                    Article placeholder images
                    <button
                        className="btn btn-primary widget-header-button pull-right"
                        onClick={this.onAddHandler}
                        disabled={isInheritingPlaceholders}
                    >
                        Add
                    </button>
                </h3>
                <div className="widget-content manage-images placeholders-gallery auto">
                    {isInheritEnabled && (
                        <StyledCheckbox
                            onEventChange={onEventChange}
                            name="inherit_placeholders"
                            checked={isInheritingPlaceholders}
                            iconClassName={
                                isInheritingPlaceholders
                                    ? "checked"
                                    : "unchecked"
                            }
                        >
                            Inheriting placeholders from Primary Insight Area
                        </StyledCheckbox>
                    )}
                    {placeholders.map(placeholder => (
                        <div className="placeholder-box" key={placeholder.url}>
                            <BackgroundImage
                                imageUrl={placeholder.url}
                                classList={["placeholder-image"]}
                                isThumbnail={true}
                            >
                                <span
                                    className="remove-image"
                                    onClick={this.onRemovePlaceholder(
                                        placeholder
                                    )}
                                />
                            </BackgroundImage>
                            <div className="placeholder-caption">
                                <textarea
                                    name={placeholder.id || placeholder.url}
                                    value={placeholder.attribution}
                                    placeholder="Attribution"
                                    className="form-control"
                                    onChange={this.onUpdatePlaceholder}
                                />
                            </div>
                        </div>
                    ))}
                    <input
                        type="file"
                        ref={fileElement => (this.fileElement = fileElement)}
                        onChange={this.onImageSelect}
                        style={{ display: "none" }}
                        accept="image/*"
                        multiple={true}
                    />
                    {placeholders.length === 0 &&
                        !isInheritingPlaceholders && <p>No placeholders</p>}
                </div>
            </div>
        )
    }
}

export default PlaceholderImageEditWidget
